var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxsearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Broken/boxsearch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.94751 13.9531L22.5038 23.5344L38.9475 14.0094M22.5 40.5256V23.5194M26.3813 40.3475C25.3125 40.9475 23.9063 41.2475 22.5 41.2475C21.0938 41.2475 19.6875 40.9475 18.6188 40.3475L8.60626 34.7975C6.33751 33.5412 4.48126 30.3912 4.48126 27.8037",
    stroke: "currentColor",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.5188 24.0562V17.1938C40.5188 14.6063 38.6625 11.4563 36.3938 10.2L26.3813 4.65C24.2438 3.45 20.7563 3.45 18.6188 4.65L8.60626 10.2C6.33751 11.4563 4.48126 14.6063 4.48126 17.1938M43.125 41.25L41.25 39.375M36 40.125C37.5913 40.125 39.1174 39.4929 40.2427 38.3676C41.3679 37.2424 42 35.7163 42 34.125C42 32.5337 41.3679 31.0076 40.2427 29.8824C39.1174 28.7571 37.5913 28.125 36 28.125C34.4087 28.125 32.8826 28.7571 31.7574 29.8824C30.6322 31.0076 30 32.5337 30 34.125C30 35.7163 30.6322 37.2424 31.7574 38.3676C32.8826 39.4929 34.4087 40.125 36 40.125V40.125Z",
    stroke: "currentColor",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxsearch);
export default __webpack_public_path__ + "static/media/boxsearch.0b89e9e37c6cd8c55f0b6304058525ad.svg";
export { ForwardRef as ReactComponent };